export const RATING_TITLES = [
  {rating: 5, title: 'Отлично'},
  {rating: 4, title: 'Хорошо'},
  {rating: 3, title: 'Нормально'},
  {rating: 2, title: 'Плохо'},
  {rating: 1, title: 'Ужасно'}
];
